import {Col, Container, Modal, Row} from "react-bootstrap";
import {AppContext} from "../../lib/AppContext";
import React, {useContext, useEffect, useState} from "react";
import {handleDefaultValues} from "../common/Utils";
import {useForm} from 'react-hook-form';
import MDButton from "../../components/MDButton";
import MDInput from "../../components/MDInput";
import {NativeSelect} from "@mui/material";
import Grid from "@mui/material/Grid";

export default function ManageAgeRangeTypeModal(props) {

  const [context, setContext] = useContext(AppContext);
  const [ageRangeType, setAgeRangeType] = useState(props.ageRangeType || {});
  const [formInvalid, setFormInvalid] = useState(false);

  useEffect(() => {
    setAgeRangeType(props?.ageRangeType);
  }, [props?.ageRangeType]);

  const handleFormChange = (e) => {
    setValue(e.target.name, e.target.value);
    let _obj = {...ageRangeType};
    _obj[e.target.name] = e.target.value;
    setAgeRangeType({..._obj});
  };

  const toggleMembershipType = (e) => {
    setValue(e.target.name, e.target.checked);
    let _obj = {...ageRangeType};
    _obj[e.target.name] = e.target.checked;
    setAgeRangeType({..._obj});
  }

  const [isNew, setIsNew] = useState(!!!props.ageRangeType?.guid);

  const {register, handleSubmit, setValue, control} = useForm({
    values: handleDefaultValues(ageRangeType)
  });

  const handleClose = () => {
    props.handleClose();
  };

  const handleSave = (data) => {
    props.handleSave(data);
  };

  return (
    <Modal onHide={handleClose} size={'lg'} show={props.show}>
      <form onSubmit={handleSubmit(handleSave)} id={'ageRangeTypeForm'}>
        <Modal.Header closeButton>
          <Modal.Title>{isNew ? 'Create New' : 'Manage'} Age Range</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col className={'col col-main'} xs={12}>
              <Container>
                <Row>
                  <Col className={'col'} sm={12} xs={12}>
                    <div className="form-group">
                      <MDInput
                        InputLabelProps={{shrink: true}}
                        placeholder={"Enter Age Range"}
                        type="text"
                        {...register('name')}
                        autoComplete="off" required
                        className="form-control" id="name"
                        label="Age Range"/>
                    </div>
                  </Col>

                </Row>
                <Row className={'mt-4'}>
                  <Col className={'col'} sm={12} xs={12}>
                    <Grid container spacing={2}>
                      <Grid item sm={6}>
                        <div className="form-group">
                          <MDInput type="number"
                                   min={1}
                                   {...register('minValue', {
                                     valueAsNumber: true
                                   })}
                                   InputLabelProps={{shrink: true}}
                                   label="Minimum Value"
                                   placeholder="ie. 6 months"
                                   className="form-control"
                                   autoComplete="off"
                                   id="minValue"/>
                        </div>
                      </Grid>
                      <Grid item sm={6}>
                          <div className="form-group native-margin-fix">
                            <label htmlFor="minDateType" className={"native-label"}>Date Type</label>
                            <NativeSelect
                              {...register('minDateType', {
                                valueAsNumber: true
                              })}
                              variant="outlined"
                              id={'minDateType'} name={'minDateType'} className={'form-control'}>
                              <option value={-1}>None</option>
                              <option value={1}>Month</option>
                              <option value={2}>Year</option>
                            </NativeSelect>
                          </div>
                      </Grid>
                    </Grid>
                  </Col>
                </Row>
                <Row className={'mt-4'}>

                  <Col className={'col'} sm={12} xs={12}>
                    <Grid container spacing={2}>
                      <Grid item sm={6}>
                        <div className="form-group">
                          <MDInput type="number"
                                   min={1}
                                   {...register('maxValue', {
                                     valueAsNumber: true
                                   })}
                                   InputLabelProps={{shrink: true}}
                                   label="Maximum Value"
                                   placeholder="ie. 6 months"
                                   className="form-control"
                                   autoComplete="off"
                                   id="minValue"/>
                        </div>
                      </Grid>
                      <Grid item sm={6}>
                        <div className="form-group native-margin-fix">
                          <label htmlFor="maxDateType" className={"native-label"}>Date Type</label>
                          <NativeSelect
                            {...register('maxDateType', {
                              valueAsNumber: true
                            })}
                            variant="outlined"
                            id={'maxDateType'} name={'maxDateType'} className={'form-control'}>
                            <option value={-1}>None</option>
                            <option value={1}>Month</option>
                            <option value={2}>Year</option>
                          </NativeSelect>
                        </div>
                      </Grid>
                    </Grid>
                  </Col>
                </Row>
              </Container>
            </Col>
          </Row>

        </Modal.Body>
        <Modal.Footer>
          <MDButton type="submit" color="info" disabled={formInvalid || props.saving}>
            {props.saving ? 'Saving...' : 'Save'}
          </MDButton>
        </Modal.Footer>
      </form>
    </Modal>
  );
}